import { isTokenValid } from "./jwtUtils";

const TOKEN_KEY = "authToken";
const CLIENT_KEY = "clientInfo";

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  sessionStorage.setItem(TOKEN_KEY, token);
}

export function clearSession() {
  sessionStorage.clear();
}

export function getClientInfo() {
  const data = sessionStorage.getItem(CLIENT_KEY);
  return data ? JSON.parse(data) : null;
}

export function setClientInfo(data) {
  sessionStorage.setItem(CLIENT_KEY, JSON.stringify(data));
}

export function isSessionValid() {
  const token = getToken();
  return token && isTokenValid(token);
}